import { useEffect, useState } from "react";

export function useIsVerified() {
  const [isVerified, setIsVerified] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined" || !window.WP_Data) {
      return;
    }
    if (!window.WP_Data?.is_user_logged_in) {
      return;
    }

    if (window.WP_Data?.email_verified) {
      return;
    }

    setIsVerified(false);
  }, [window.WP_Data]); // eslint-disable-line react-hooks/exhaustive-deps

  return isVerified;
}
